module.exports = __webpack_public_path__ + "media/images/flags/LR-2c88cfb5cfd8f85ffaf50387eb51f163.svg";